import GenderCommunication from '~/pages/communication/gender/libs/components/GenderCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const GenderCommunicationPage = (props: TPageProps) => (
  <GenderCommunication {...props} />
)

export default GenderCommunicationPage
